/* Copies contact-form enquiries to the TUN Command Centre so a proposal can be prepared straight away.
   Runs alongside Shopify's normal contact form and never blocks or changes it. */
(function () {
  var ENDPOINT = "https://tun-brain-mcp.mk-f41.workers.dev/enquiry";
  document.addEventListener("submit", function (event) {
    try {
      var form = event.target;
      if (!form || !form.querySelector) return;
      var type = form.querySelector('input[name="form_type"]');
      if (!type || type.value !== "contact") return;
      if (form.closest && form.closest("footer, .newsletter, [id*='newsletter'], [class*='newsletter']")) return;
      var fields = {}, order = [];
      new FormData(form).forEach(function (value, key) {
        var m = /^contact\[(.+)\]$/.exec(key);
        if (!m || typeof value !== "string" || !value.trim()) return;
        fields[m[1].toLowerCase()] = value.trim(); order.push(m[1]);
      });
      var pick = function () { for (var i = 0; i < arguments.length; i++) if (fields[arguments[i]]) return fields[arguments[i]]; return ""; };
      var email = pick("email");
      if (!email) return;
      var used = ["name", "email", "phone", "body", "message", "company", "business", "business name", "users", "staff", "request type", "service", "tags"];
      var extra = order.filter(function (k) { return used.indexOf(k.toLowerCase()) < 0; }).map(function (k) { return k + ": " + fields[k.toLowerCase()]; });
      var message = pick("body", "message") + (extra.length ? "\n\n" + extra.join("\n") : "");
      if (!message.trim()) message = "(No message — enquiry from " + location.pathname + ")";
      var payload = { name: pick("name") || email, business: pick("company", "business", "business name"), email: email, phone: pick("phone"), service: pick("request type", "service", "technology area") || document.title, staff: pick("users", "staff"), message: message.slice(0, 5000), page: location.pathname };
      fetch(ENDPOINT, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload), keepalive: true, mode: "cors" }).catch(function () {});
    } catch (e) { /* never interfere with the store's own form */ }
  }, true);
})();
